var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5545 8.9887L8.41575 4.12745C9.02575 3.51745 9.9045 3.40682 10.5151 4.01682C11.1258 4.62682 11.0151 5.5062 10.4045 6.1162L5.322 11.1987C4.43825 12.0824 2.67013 12.0824 1.56575 10.9774C0.46075 9.87245 0.46075 8.10495 1.3445 7.2212L6.427 2.1387C7.19122 1.3884 8.22081 0.97022 9.29177 0.975141C10.3627 0.980062 11.3884 1.40768 12.1457 2.16498C12.903 2.92227 13.3306 3.94797 13.3356 5.01893C13.3405 6.08989 12.9223 7.11948 12.172 7.8837L9.2995 10.7562",
    stroke: "#DCDCEC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclips);
export default __webpack_public_path__ + "static/media/paperclips.2654abae60168dfcf01d35481cd65f0f.svg";
export { ForwardRef as ReactComponent };